export * as CommunicationRules from './communication';
export * as WhatsappBusinessRules from './whatsapp';
